module.exports = __webpack_public_path__ + "static/media/detail_0043_t.52910f5e.jpg";